import { useEffect, useState } from 'react';

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.matchMedia('(max-width: 1024px)').matches);

  useEffect(() => {
    const media = window.matchMedia('(max-width: 1024px)');
    const handler = () => setIsMobile(media.matches);

    media.addEventListener('change', handler);
    return () => media.removeEventListener('change', handler);
  }, []);

  return isMobile;
};

export default useIsMobile;
